<template>
  <div>
    <el-tabs
      v-model="activeName"
      type="card"
    >
      <el-tab-pane
        label="交收汇总"
        name="settlementInquiry"
      >
        <settlementInquiry />
      </el-tab-pane>
      <el-tab-pane
        label="交收明细"
        name="settlementDetailInquiry"
      >
        <settlementDetailInquiry />
      </el-tab-pane>
      <el-tab-pane
        label="历史交收汇总"
        name="historicalSettlementInquiry"
      >
        <historicalSettlementInquiry />
      </el-tab-pane>
      <el-tab-pane
        label="历史交收明细"
        name="historicalSettlementDetailInquiry"
      >
        <historicalSettlementDetailInquiry />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import settlementInquiry from './settlement-inquiry'
import settlementDetailInquiry from './settlement-detail-inquiry'
import historicalSettlementInquiry from './historical-settlement-inquiry'
import historicalSettlementDetailInquiry from './hisrotical-settlement-detail-inquiry'
export default {
  name: 'Index',
  components: {
    settlementInquiry,
    settlementDetailInquiry,
    historicalSettlementInquiry,
    historicalSettlementDetailInquiry
  },
  data () {
    return {
      activeName: 'settlementInquiry',
    }
  }
}

</script>
